import React from 'react';
import { ShieldCheck } from 'lucide-react';

export function LicenseBadge({ compact = false }) {
  return (
    <span
      data-testid="license-badge"
      className={`inline-flex items-center gap-2 rounded-full border border-[hsl(var(--brand-gold))]/40 bg-[hsl(var(--brand-gold))]/10 px-3 py-1 text-xs font-medium text-[hsl(var(--brand-navy))] ${compact ? '' : 'shadow-sm'}`}
    >
      <ShieldCheck className="h-3.5 w-3.5 text-[hsl(var(--brand-gold))]" />
      License N° L16195/CFL
    </span>
  );
}
